
window.ValidarEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

window.MonedaFiltro = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '$0.00'
  }
  if (typeof value !== 'number') {
    value = parseFloat(value)
  }
  var formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits: 2,
  })
  let moneda = formatter.format(value);
  let monedaArr = moneda.split(".");
  if(parseFloat(monedaArr[1]) > 0){
    return moneda
  }
  return monedaArr[0];
}

window.Vue.filter('moneda', function (value) {
  return MonedaFiltro(value)
})

window.Vue.filter('numero', function (value) {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.0'
  }
  if (typeof value !== 'number') {
    value = parseFloat(value)
  }
  var formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 1,
  })
  return formatter.format(value).replace("$", "")
})

window.Vue.filter('fecha', function (fecha, formato = 'DD/MM/YYYY HH:mm', placeholder = null) {
  if (fecha === null || fecha === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return fecha
  }
  let fechaFormat = dayjs(fecha, 'YYYY-MM-DD HH:mm:ss').format(formato)
  fechaFormat = fechaFormat.substring(0, 1).toUpperCase() + fechaFormat.substring(1)
  return fechaFormat
})

window.Vue.filter('fecha_simple', function (fecha, formato = 'DD/MM/YYYY', placeholder = null) {
  if (fecha === null || fecha === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return fecha
  }
  let fechaFormat = dayjs(fecha, 'YYYY-MM-DD').format(formato)
  fechaFormat = fechaFormat.substring(0, 1).toUpperCase() + fechaFormat.substring(1)
  return fechaFormat
})

window.Vue.filter('fecha_texto', function (fecha, placeholder = null) {
  if (fecha === null || fecha === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return fecha
  }
  let fechaFormat = dayjs(fecha, 'YYYY-MM-DD')
  // return `${fechaFormat.date()} de ${fechaFormat.format('MMMM')} del ${fechaFormat.year()}`;
  return `${fechaFormat.date()} ${fechaFormat.format('MMMM')}`;
})

window.Vue.filter('fecha_tz', function (fecha, formato = 'DD/MM/YYYY HH:mm', placeholder = null) {
  if (fecha === null || fecha === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return fecha
  }
  return dayjs(fecha, 'YYYY-MM-DD HH:mm:ss').tz('America/Mexico_City').format(formato)
})

window.Vue.filter('hora', function (hora, formato = 'HH:mm', placeholder = null) {
  if (hora === null || hora === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return hora
  }
  return dayjs(hora, 'HH:mm:ss').format(formato)
})

window.Vue.filter('horaSplit', function (hora, formato = 'HH:mm', placeholder = null) {
  if (hora === null || hora === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return hora
  }

  let horaArr = hora.split(",")
  return horaArr.map(item => dayjs(item, 'HH:mm:ss').format(formato)).join(", ")
})

window.Vue.filter('tiempo_mensaje', function (fecha, formato = 'DD/MM/YYYY HH:mm', placeholder = null) {
  if (fecha === null || fecha === undefined) {
    if(placeholder != null){
      return placeholder
    }
    return fecha
  }
  let fechaFormat = dayjs(fecha, 'YYYY-MM-DD HH:mm:ss')
  let horaActual = dayjs();
  if(horaActual.diff(fechaFormat, 'seconds') < 60){
    return horaActual.diff(fechaFormat, 'seconds') + " s"
  }
  else if(horaActual.diff(fechaFormat, 'minutes') < 60){
    return horaActual.diff(fechaFormat, 'minutes') + " m"
  }
  else if(horaActual.diff(fechaFormat, 'hours') < 24){
    return horaActual.diff(fechaFormat, 'hours') + " h"
  }
  else if(horaActual.diff(fechaFormat, 'days') < 28){
    return horaActual.diff(fechaFormat, 'days') + " d"
  }
  else {
    return horaActual.diff(fechaFormat, 'months') + " m"
  }
})



window.Vue.filter('textoSecreto', function (texto, mostrar) {
  if (mostrar || texto == null || texto.length == 0) {
    return texto
  }
  return 'Mostrar'
})
